import React from "react";
import Styles from './styles.module.scss';
// import Logo from "../_UI/logo";
import {useDispatch, useSelector} from "react-redux";
import {setMobileNavStatus} from "../../store/cabinet/action";

import userIcon from '../../theme/assets/other/ftf_user_icon.png';


const CabinetHeader = () => {
    const dispatch = useDispatch();

    const mobileNavStatus = useSelector(store => store.cabinet.mobileNavStatus);
    const userData = useSelector(store => store.cabinet.userData);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer} ${mobileNavStatus ? Styles.contentWrapWAbs : null}`}>
                <div className={`${Styles.burgerBtn}`} onClick={()=>{dispatch(setMobileNavStatus(!mobileNavStatus))}}>
                    <div/>
                    <div/>
                    <div/>
                </div>
                <div className={`${Styles.userWrap}`}>
                    <div className={`${Styles.userContentBox}`}>
                        <div className={`${Styles.userContentBoxName}`}>{userData?.user?.username}</div>
                        <div className={`${Styles.userContentBoxBalance}`}>{userData?.user?.coins * 1} <span className={`${Styles.colorRed}`}>FTF</span> = 0 <span className={`${Styles.colorGreen}`}>USDT</span></div>
                    </div>
                    <div className={`${Styles.userIconBox}`}>
                        <img src={userData?.user?.avatar ? userData?.user?.avatar : userIcon} alt={userData?.user?.username}/>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetHeader;